import React from 'react';
import facenail from '../assets/facenail.webp';
import pedicuregallery from '../assets/pedicuregallery.webp';
import happyclient from '../assets/happyclient.webp';
import naildesign from '../assets/naildesign.jpeg';
import modernhair from '../assets/eyelash.jpg';
import pedicurerelax from '../assets/pedicurerelax.webp';
import eleganthair from '../assets/eleganthair.jpg';
import './Gallery.css';


const Gallery = () => {
  return (
    <>
        
      <div className="container">
        <h1 style={{ fontWeight: 300, fontFamily: "'Montserrat', sans-serif", fontStyle: 'italic' }}>Discover Our Work</h1>
        <p>Explore our portfolio of stunning nail designs, relaxing pedicure treatments, and happy clients. From simple elegance to bold statements, we bring every vision to life.</p>

        <div className="gallery">
            <img src={facenail} alt="Nail Design 1" />
            <img src={pedicuregallery} alt="Pedicure Treatment" />
            <img src={happyclient} alt="Happy Client" />
            <img src={naildesign} alt="Nail Design 2" />
            <img src={modernhair} alt="Modern Hair Cut" />

            <img src={pedicurerelax} alt="Relaxing Pedicure " />
            <img src={eleganthair} alt="Elegant Hair Style" />
        </div>
    </div>

    
    </>
  )
}
export default Gallery;